export enum BUTTON_ELEMENT_ACTION_TYPES {
  GO_TO_MAPS = 1,
  MAIL_TO = 2,
  CALL = 3,
}
